import { useEffect, useState } from 'react';
import { IUsuario } from '@/@types/Comunidade';
import { api } from '@/services/api';
import { DocenteItem } from '@/components/PagesComponents/Comunidade/DocenteItem';
import { Loading } from '@/components/shared/Loading';


interface IPosDoutorado extends IUsuario {
}

// const tipoDocenteDescricoes = [
//     'Docente Pleno - Pós-graduação', 0
//     'Docente Participante', 1
//     'PPPD - Pós-graduação', 2
//     'PAD', 3
//     'PED', 4
//     'Pesquisador Colaborador', 5
//     'Pesquisador Visitante Convidado', 6
//     'Professor Colaborador', 7
//     'Visitante' 8
// ];

const PosDoutorado = () => {
    const [posDoutorado, setPosDoutorado] = useState<IPosDoutorado[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getPosDoutorado = async () => {
            setIsLoading(true);
            const url = 'user/register/TipoDocentes/2';

            await api.get(url)
                .then(response => {
                    setPosDoutorado(response.data)
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => setIsLoading(false));
        }

        getPosDoutorado();

    }, [])

    return (
        <>
            <h1>Pós-Doutorado</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <div>
                    {posDoutorado.map(pesquisador => (
                        <DocenteItem key={pesquisador._id} data={pesquisador} />
                    ))}
                </div>
            )}
        </>
    );
}

export { PosDoutorado }